import React from "react";
import cx from "classnames";
import { FormContext, GatingManager, WidgetActions, WidgetContent, Widgets, WidgetsContext } from "@paperflite-marketing/cleverstory-commons";
import { useFormActions } from "./hooks/useFormContext";
import { useWidgetContext } from "./hooks/useWigetContext";
import { useContentManagerActions } from "./hooks/useContentManagerActions";
import _ from "lodash";
import { useSelector } from "react-redux";
import styles from "../preview.module.scss";

const PageWithContext = ({
  frames,
  storyboard,
  desktop,
  pagesById,
  domainUrl,
  gatingConfigurations,
  gatingRef,
  handleResetGating,
}) => {
  const page = pagesById[frames[0].pageId];
  const { loading = false, personalizationId = null } = page;
  const { widgetContextState, editorSession } = useWidgetContext({
    desktop,
    personalizationId,
    page,
    domainUrl,
    storyboard,
  });
  const formActions = useFormActions();
  const contentManagerProps = useContentManagerActions(editorSession);
  return (
    <WidgetsContext.Provider value={widgetContextState}>
      <FormContext.Provider value={formActions}>
          <GatingManager
            ref={gatingRef}
            configurations={gatingConfigurations}
            resetGating={handleResetGating}
            appearance={storyboard.appearance}
            storyboardType={storyboard.type}
            page={page.canonical}
            breakpoint={widgetContextState.breakpoint}
            onGatingClose={() => null}
            triggerGatingInteraction={() => null}
            preview={true}
          >
          <WidgetContent.Manager {...contentManagerProps}>
            <WidgetActions.Provider value={{ onBeforeExecution: () => {} }}>
              {loading ? <LoadingScreen /> : <PageRenderer
                frames={frames}
                breakpoint={widgetContextState.breakpoint}
                editorSession={editorSession}
              />}
            </WidgetActions.Provider>
          </WidgetContent.Manager>
        </GatingManager>
      </FormContext.Provider>
    </WidgetsContext.Provider>
  );
};

export default PageWithContext;

const PageRenderer = ({ frames = [], breakpoint, editorSession }) => {
  const widgets = useSelector((state) => _.get(state, `${editorSession}.present.widgets`, []));
  const widgetMap = _.keyBy(widgets, "uid");

  return _.orderBy(frames, "order", "desc").map(({ uid }) => (
    <Widgets
      key={uid}
      widgetProps={widgetMap[uid]}
      breakpoint={breakpoint}
      data-icv2-live
    />
  ));
};


const LoadingScreen = () => {
  return (
    <div className={cx("loading", styles.message)}>
      <span className={styles.loadingDot}></span>
      <span className={styles.loadingDot}></span>
      <span className={styles.loadingDot}></span>
    </div>
  );
};
